import { NormalizedProductVariant } from "@cappelendamm/catalogue/crystallize/product-translator.js";
import {
  Cart,
  ORDER_META_KEY,
  PRODUCT_BUNDLE_FORMATS,
} from "@cappelendamm/e-commerce-services";
import { getMetaValueFromKey } from "@cappelendamm/crystallize-utils";

const DIGITAL_BINDINGS = [
  "Nedlastbar lydbok",
  "Ebok",
  "Lydbok",
  PRODUCT_BUNDLE_FORMATS.COMBINATION,
  PRODUCT_BUNDLE_FORMATS.DIGITAL,
];

export function isItemDigital(item?: Cart["items"][number]): boolean {
  const binding = item?.variant?.attributes?.Innbinding;
  if (!binding) return false;
  return DIGITAL_BINDINGS.includes(binding);
}

export function isProductDigital(item: NormalizedProductVariant): boolean {
  if (item.itemType === "book")
    return (
      !!item.itemDetails.binding &&
      DIGITAL_BINDINGS.includes(item.itemDetails.binding)
    );
  if (item.itemType === "product-bundle")
    return !!item.itemDetails.products?.some((v) =>
      v.attributes?.some(
        (attribute) =>
          !!attribute && DIGITAL_BINDINGS.includes(attribute.value),
      ),
    );
  if (item.itemType === "digital-service") return false;
  return false;
}

export function isItemDigitalStringComparison(binding: string): boolean {
  return DIGITAL_BINDINGS.includes(binding);
}

export function isOrderItemDigital(product: {
  type?: string;
  meta?: Array<{ key: string; value?: string }>;
}): boolean {
  if (product.type === "digital") return true;

  const binding = getMetaValueFromKey(
    product.meta,
    ORDER_META_KEY.ORDER_ITEM.BINDING,
  ) as string;

  return !binding || isItemDigitalStringComparison(binding);
}
